export default __webpack_public_path__ + "static/media/gallery-wip-grenade v2_09.5186a015.jpg";